import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD} from "../../../constants/unlock_choice_price_negotiation";

interface IProps {
    vendorName: string | null;
    isSending: boolean;
    isConfirmDisabled: boolean;
    isArmed: boolean;
    onConfirm: () => void;
}

export const UnlockChoiceModalPriceNegotiationFooter = (props: IProps) => {
    const {vendorName, isSending, isConfirmDisabled, isArmed, onConfirm} = props;

    const vendorLabel = vendorName ? `dewelopera ${vendorName}` : "dewelopera";

    return (
        <ResponsiveModal.Footer className={footerStyle}>
            <div className={ctaStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    isLoading={isSending}
                    disabled={isConfirmDisabled || isSending}
                    aria-disabled={isArmed ? undefined : true}
                    onClick={onConfirm}
                    dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_PRICE_NEGOTIATION_CONFIRM_BUTTON}
                >
                    {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD.ctaText}
                </Button>
            </div>

            <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" align="center" className={clauseStyle}>
                Po kliknięciu w przycisk prześlemy Twoje dane kontaktowe do {vendorLabel}, który porozmawia z Tobą bez zobowiązań.
            </Text>
        </ResponsiveModal.Footer>
    );
};

const footerStyle = css({
    px: 2,
    md: {
        px: 3,
        pb: 1.5
    }
});

const ctaStyle = css({
    py: 1.5
});

const clauseStyle = css({
    fontSize: "1.067rem",
    lineHeight: "1.2rem",
    py: 1.5
});
import {css} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD} from "../../../constants/unlock_choice_price_negotiation";

interface IProps {
    vendorName: string | null;
    isSending: boolean;
    isConfirmDisabled: boolean;
    isArmed: boolean;
    onConfirm: () => void;
}

export const UnlockChoiceModalPriceNegotiationFooter = (props: IProps) => {
    const {vendorName, isSending, isConfirmDisabled, isArmed, onConfirm} = props;

    const vendorLabel = vendorName ? `dewelopera ${vendorName}` : "dewelopera";

    return (
        <ResponsiveModal.Footer className={footerStyle}>
            <div className={ctaStyle}>
                <Button
                    type="button"
                    variant="filled_primary"
                    size="medium"
                    fullWidth
                    isLoading={isSending}
                    disabled={isConfirmDisabled || isSending}
                    aria-disabled={isArmed ? undefined : true}
                    onClick={onConfirm}
                    dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_PRICE_NEGOTIATION_CONFIRM_BUTTON}
                >
                    {UNLOCK_CHOICE_PRICE_NEGOTIATION_LEAD.ctaText}
                </Button>
            </div>

            <Text as="p" variant="info_txt_1" color="var(--colors-gray-700)" align="center" className={clauseStyle}>
                Po kliknięciu w przycisk prześlemy Twoje dane kontaktowe do {vendorLabel}, który porozmawia z Tobą bez zobowiązań.
            </Text>
        </ResponsiveModal.Footer>
    );
};

const footerStyle = css({
    px: 2,
    md: {
        px: 3,
        pb: 1.5
    }
});

const ctaStyle = css({
    py: 1.5
});

const clauseStyle = css({
    fontSize: "1.067rem",
    lineHeight: "1.2rem",
    py: 1.5
});
